module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Secretly Smitten")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "ontents",
      "id": "p0007-d6e12",
      "src": "images/9781401687137_IN_0007_002.jpg"
    }
  })])]), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-03-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter51",
      "id": "a_1"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0008-04-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter17",
      "id": "a_2"
    }
  }, [_c('i', [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0009-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "id": "a_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00010-04-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "id": "a_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00011-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "id": "a_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00011-04-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "id": "a_55",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00012-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "id": "a_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00013-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23",
      "id": "a_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00014-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "id": "a_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0015-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "id": "a_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00016-04-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "id": "a_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00018-05-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50",
      "id": "a_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Reading Group Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00019-06-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/excerpt",
      "id": "a_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Excerpt from")]), _vm._v(" The Scent of Rain")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p00020-06-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55",
      "id": "a_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Author Bio")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6044f85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 63
// module chunks = 0